import React from 'react';
import { css, Global } from '@emotion/react';
import AppTheme from '@/theme';

const style = css`
  @import url('https://cdn.rawgit.com/moonspam/NanumSquare/master/nanumsquare.css');

  html {
    font-size: 62.5%;
    box-sizing: border-box;
    line-height: 1.2;
    overflow-x: hidden;
    -webkit-text-size-adjust: none;
    -ms-content-zooming: none;
    -ms-touch-action: pan-x pan-y;
    text-size-adjust: none;
  }

  body {
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: ${AppTheme.fontFamily.primaryFont};
    font-size: 1.6rem;
    padding: 0;
    margin: 0;
    word-break: keep-all;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
  }

  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  a {
    color: inherit;
    font-size: inherit;
    text-decoration: none;
  }

  ul,
  li {
    list-style: none;
  }

  button {
    color: inherit;
    font: inherit;
    cursor: pointer;
    background: inherit;
  }

  /* 웹킷 브라우저 (예: 크롬, 사파리)용 */
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox 브라우저용 */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  input[type='date']::-webkit-datetime-edit-text {
    -webkit-appearance: none;
    display: none;
  }

  input[type='date']::-webkit-datetime-edit-month-field {
    -webkit-appearance: none;
    display: none;
  }

  input[type='date']::-webkit-datetime-edit-day-field {
    -webkit-appearance: none;
    display: none;
  }

  input[type='date']::-webkit-datetime-edit-year-field {
    -webkit-appearance: none;
    display: none;
  }

  body::-webkit-scrollbar {
    width: 8px;
  }

  body::-webkit-scrollbar-thumb {
    height: 10%; /* 스크롤바의 길이 */
    background: #e8e8e8; /* 스크롤바의 색상 */
    background-clip: padding-box;
    border-radius: 120px;
  }

  body::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }

  *:not(body)::-webkit-scrollbar {
    width: 20px; /* 스크롤바의 너비 */
  }

  *:not(body)::-webkit-scrollbar-thumb {
    height: 10%; /* 스크롤바의 길이 */
    border-radius: 60px;
    background: #e8e8e8;
    border: 5px solid transparent;
    background-clip: padding-box;
  }

  *:not(body)::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }

  * {
    scrollbar-width: thin; /* 또는 auto */
    scrollbar-color: #e8e8e8 transparent; /* 스크롤바 색상 및 트랙 색상 */
  }

  /* 수평 스크롤바 */
  * {
    scrollbar-width: thin; /* 또는 auto */
    scrollbar-color: #e8e8e8 transparent; /* 스크롤바 색상 및 트랙 색상 */
  }

  .ellipsis-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .ellipsis-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ellipsis-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  //  Phone input country icon height
  .PhoneInputCountry {
    max-height: 5.6rem;
  }

  .PhoneInputInput {
    margin-top: 0 !important;
  }
`;

const GlobalStyles = () => <Global styles={style} />;

export default GlobalStyles;
